// extracted by mini-css-extract-plugin
module.exports = {"logoDiv":"Rozwoj_logoDiv__1F_6M","logo":"Rozwoj_logo__3u_VL","eu":"Rozwoj_eu__2omGX","title":"Rozwoj_title__3eJen","para":"Rozwoj_para__OgucL"};